import React from 'react'
import PropTypes from 'prop-types'
import Interweave from 'interweave'
import { convertMdToHtml } from '..'
import Section from '../../Section'

const AdherenceToSpecification = ({ report: { reportContent } }) => (
  <Section title="Adherence to Specification">
    <Interweave
      content={convertMdToHtml.makeHtml(reportContent.breakdownAndAutomatedAnalysis.specReviewText)}
    />
  </Section>
)

AdherenceToSpecification.propTypes = {
  report: PropTypes.object,
}

export default AdherenceToSpecification
